import commonRegion from './locality-common-region';
var LocalityCommonDistrict = {
  GREATER_QUEANBEYAN: {
    districtId: 2131,
    name: 'Greater Queanbeyan',
    region: commonRegion.QUEANBEYAN,
    slug: 'greater-queanbeyan-queanbeyan-region-nsw'
  },
  YASS_VALLEY: {
    districtId: 2431,
    name: 'Yass Valley',
    region: commonRegion.SOUTHERN_TABLELANDS,
    slug: 'yass-valley-southern-tablelands-nsw'
  }
};
export default LocalityCommonDistrict;